// TODO: После доработки UI компонентов Input, Checkbox и других - заменить MUI компоненты на наши кастомные
// и применить их в этой форме регистрации

import React from "react";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

import { useAppContext } from "../../../../AppContext";
import { UserRole } from "../../../../apis/AuthApi";
import PasswordTextField from "../../../../components/common/PasswordTextField";
import LinkWithRedirect from "../../../../components/common/LinkWithRedirect";
import { Button } from "../../../../ui/Button/Button";
import { RegisterSchema } from "./schemas/RegisterSchema";
import { ROUTES } from "../../../../constants/routes";
import classes from "./styles.module.scss";

export const RegisterForm = () => {
  const { api } = useAppContext();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      password: "",
      accept: false,
    },
    validationSchema: RegisterSchema(t),
    onSubmit: async (values, { setErrors }) => {
      const isAthlete = params.has("redirect")
        ? params.get("redirect")!.indexOf("/addmetocoach") > -1
        : false;
      try {
        const result = await api.authApi.register({
          fullName: values.fullName,
          email: values.email,
          password: values.password,
          consent: values.accept,
          role: isAthlete ? UserRole.Athlete : null,
        });
        if (result.success) {
          if (params.has("redirect")) {
            const redirectUrl = params.get("redirect");
            navigate(ROUTES.LOGIN + ROUTES.VERIFY_CODE + "?redirect=" + redirectUrl);
          } else {
            navigate(ROUTES.LOGIN + ROUTES.VERIFY_CODE);
          }
        }
      } catch (error: any) {
        if (error?.response?.status === 400) {
          const errorData = error?.response?.data;
          if (errorData === "user_exist") {
            setErrors({ email: t("userAlreadyExists") });
          } else if (errorData?.Code === "PasswordTooShort") {
            setErrors({ password: errorData.Description || t("passwordTooShort") });
          }
        }
      }
    },
  });

  return (
    <div className={classes.wrapper}>
      <Typography variant="h4" className={classes.title}>
        {t("joinForFree")}
      </Typography>
      
      <form onSubmit={formik.handleSubmit} autoComplete="off" noValidate>
        <Stack spacing={56}>
          <Stack spacing={0}>
            <Grid container gap={37}>
              <Grid item xs={12} style={{ position: "relative" }}>
                <TextField
                  className="yna"
                  autoComplete="off"
                  type="text"
                  name="fullName"
                  label={t("nameInput")}
                  variant="outlined"
                  fullWidth
                  value={formik.values.fullName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.errors.fullName !== undefined && formik.submitCount > 0}
                  inputProps={{
                    autoComplete: "off",
                    "data-form-type": "other",
                  }}
                />
                {formik.errors.fullName && formik.submitCount > 0 ? (
                  <div className={classes.errorMessage}>{formik.errors.fullName}</div>
                ) : null}
              </Grid>
              <Grid item xs={12} style={{ position: "relative" }}>
                <TextField
                  className="yna"
                  autoComplete="off"
                  type="email"
                  name="email"
                  label={t("emailInput")}
                  variant="outlined"
                  fullWidth
                  error={formik.errors.email !== undefined && formik.submitCount > 0}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  inputProps={{
                    autoComplete: "off",
                    "data-form-type": "other",
                  }}
                />
                {formik.errors.email && formik.submitCount > 0 ? (
                  <div className={classes.errorMessage}>{formik.errors.email}</div>
                ) : null}
              </Grid>
              <Grid item xs={12} style={{ position: "relative" }}>
                <PasswordTextField
                  className="yna"
                  autoComplete="new-password"
                  name="password"
                  label={t("passwordInput")}
                  variant="outlined"
                  fullWidth
                  error={formik.errors.password !== undefined && formik.submitCount > 0}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.errors.password && formik.submitCount > 0 ? (
                  <div className={classes.errorMessage}>{formik.errors.password}</div>
                ) : null}
              </Grid>
            </Grid>
          </Stack>

          <Stack spacing={17}>
            <FormControlLabel
              name="accept"
              control={<Checkbox size="small" />}
              className={classes.checkboxLabel}
              label={
                <>
                  <span className={classes.agreeText}>{t("agree")}</span>{" "}
                  <span>
                    <Link
                      to={t("terms")}
                      target="_blank"
                      className={classes.loginPageLink}
                    >
                      <Typography component="span">
                        {t("termsLabel")}
                      </Typography>
                    </Link>
                    &nbsp;<span className={classes.andText}>{t("and")}</span>&nbsp;
                    <Link
                      to={t("privacyPolicyUrl")}
                      target="_blank"
                      className={classes.loginPageLink}
                    >
                      <Typography component="span">
                        {t("privacyPolicyLabel")}
                      </Typography>
                    </Link>
                  </span>
                </>
              }
              checked={formik.values.accept}
              value={formik.values.accept}
              onChange={formik.handleChange}
            />
            
            <Button
              buttonSize="lg"
              type="submit"
              disabled={!formik.values.accept}
              fullWidth
            >
              {t("createAccountButton")}
            </Button>

            <Grid
              container
              flexWrap={"wrap"}
              justifyContent={"center"}
              className={classes.registrationWrapper}
            >
              <Grid item display={"flex"} alignContent={"center"}>
                <Typography className={classes.registrationPrompt} variant="body1">
                  {t("alreadyHaveAccount")}
                </Typography>
              </Grid>
              <Grid item flexWrap={"wrap"} display={"flex"} alignContent={"center"}>
                <LinkWithRedirect to={ROUTES.LOGIN} className={classes.loginPageLink}>
                  <Typography component="span">
                    &nbsp;{t("alreadyHaveLogin")}
                  </Typography>
                </LinkWithRedirect>
              </Grid>
            </Grid>
          </Stack>
        </Stack>
      </form>
    </div>
  );
};
